import * as ActionUtility from '@utilities/action-utility'

const SET_LEGAL_RESPONSIBLE_FIELD = 'Aberto.Onboarding.SET_LEGAL_RESPONSIBLE_FIELD'

const setLegalResponsibleField = (name, value) => {
  return ActionUtility.createAction(SET_LEGAL_RESPONSIBLE_FIELD, { name, value })
}

export { setLegalResponsibleField, SET_LEGAL_RESPONSIBLE_FIELD }
